import { Button, Dialog, DialogContent, Box, Typography } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Fragment } from 'react/jsx-runtime';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
interface Props {
	open: boolean;
	handleClose: () => void;
	text?: string;
	meesage?: string;
}

const DialogSuccess: FC<Props> = ({ open, meesage = '', text = 'your_campaign_is_success_created', handleClose }) => {
	const { t } = useTranslation();
	return (
		<Fragment>
			<Dialog open={open} onClose={handleClose} maxWidth="xs" aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
				<DialogContent>
					<Box className="flex justify-start text-success-main">
						<CheckCircleIcon fontSize="large" color="primary" />
						{meesage}
					</Box>
					<Typography id="alert-dialog-description" className="my-5 break-words text-center text-lg">
						{t(text)}
					</Typography>
					<Box className="flex justify-center">
						<Button onClick={handleClose} color="primary">
							{t('close')}
						</Button>
					</Box>
				</DialogContent>
			</Dialog>
		</Fragment>
	);
};

export default DialogSuccess;
